export default __webpack_public_path__ + "static/a1_cloud_services_in_a_box-b7b6837cbed01058892ab2fb7278c172.webp";